export default {
  report_type: null,
};
